export const environment = {
  production: true,
  test_env: true,
  tokenName: 'token-test-rm',
  headerName: 'X-Auth-CNW',
  pagamento_paypal: false,
  pagamento_paypal_subscription: true,
  pagamento_banca_ricorrente: true,
  pagamento_banca_semplice: true,
  pagamento_contratto: true,
  paypal_env: 'sandbox',
  ga_track: 'UA-141102437-1',
  url_root: 'https://test.casanelweb.it/rest_ws/'
};



// WEBPACK FOOTER //
// /home/david/vscode-workspace/TOP-casa-nel-web/frontend/src/environments/environment.ts